import { type Dispatch, type SetStateAction } from 'react'

import { NOW_SLOT_TYPES } from 'shared/services/api/models/now/NowSlot'
import { type NowDataStateSlot } from 'types/redux'

export const fixNumberToDoubleZero = (input: number): string => {
  return input <= 9 ? `0${input}` : input.toString()
}

export const timeHandler = (countdownTime: number) => {
  const currentTime = new Date()

  const now = currentTime.getTime()
  const countDownDate = currentTime.setSeconds(
    currentTime.getSeconds() + countdownTime
  )

  const distance = countDownDate - now

  const hours = Math.floor(distance / (1000 * 60 * 60))
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((distance % (1000 * 60)) / 1000)

  return { hours, minutes, seconds }
}

export const setTimeleft = (
  countdownTime: string,
  setTimeLeft: Dispatch<SetStateAction<string>>,
  setCountdownTime: Dispatch<SetStateAction<string>>
) => {
  if (parseInt(countdownTime) >= 0) {
    const { hours, minutes, seconds } = timeHandler(parseInt(countdownTime))

    return setInterval(() => {
      setTimeLeft(
        `${fixNumberToDoubleZero(hours)}:${fixNumberToDoubleZero(
          minutes
        )}:${fixNumberToDoubleZero(seconds)}`
      )
      setCountdownTime((parseInt(countdownTime) - 1).toString())
    }, 1000)
  }
}

export const sortSlotsBySecondsLeft: (
  slots: NowDataStateSlot[]
) => NowDataStateSlot[] = slots =>
  slots.sort((a, b) => {
    return (a.secondsLeft ?? 0) < (b.secondsLeft ?? 0) ? 1 : -1
  })

export const getSameDaySlotsSortedBySecondsLeft: (
  slots?: NowDataStateSlot[]
) => NowDataStateSlot[] = slots => {
  if (!slots?.length) {
    return []
  }
  //try to find only samDay slots
  let eligibleSlots: NowDataStateSlot[] = slots.filter(
    (item: NowDataStateSlot) => item.type === NOW_SLOT_TYPES.SAME_DAY
  )

  // if no sameDay slots use whatever we have in slots
  if (!eligibleSlots.length) {
    eligibleSlots = slots
  }

  // sort slots by secondsLeft, high to low
  return sortSlotsBySecondsLeft(eligibleSlots)
}
